import Navbar      from '../components/Navbar';
import FieldSignal from '../components/FieldSignal';
import HeroVideo   from '../components/HeroVideo';
import HeroNoise   from '../components/HeroNoise';
import Kirkmark    from '../components/Kirkmark';

export default function Hero() {
  return (
    <section
      id="hero"
      aria-label="Inicio"
      className="relative h-screen min-h-[700px] p-4 md:p-6 overflow-hidden"
    >
      <div
        className="relative h-full rounded-3xl md:rounded-[2rem] overflow-hidden bg-carbon bg-cover bg-center"
        style={{ backgroundImage: "url('/baqueano-hero-start.jpg')" }}
      >
        <HeroVideo src="/baqueano-hero.mp4" poster="/baqueano-hero-start.jpg" />
        <HeroNoise />
        {/* dual gradient mask: dim top + bottom for legibility */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              'linear-gradient(180deg, rgba(20,17,13,0.55) 0%, rgba(20,17,13,0) 28%, rgba(20,17,13,0) 60%, rgba(20,17,13,0.7) 100%)',
          }}
        />

        <Navbar />
        <FieldSignal className="absolute top-[76px] left-5 md:left-8 z-10">
          FIELD SIGNAL · LIVE · 2026
        </FieldSignal>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 md:px-8">
          <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-papel/70 mb-6">
            LIC. EN SISTEMAS · IA APLICADA
          </div>
          <h1
            className="text-papel"
            style={{ fontSize: 'clamp(64px, 13vw, 220px)' }}
          >
            <Kirkmark animate />
          </h1>
          <p className="font-display italic font-display-italic-axes font-light text-papel/85 mt-7 max-w-2xl leading-[1.2]"
             style={{ fontSize: 'clamp(20px, 3vw, 34px)' }}>
            Detrás de Baqueano.
          </p>
        </div>

        <div className="absolute bottom-7 left-0 right-0 flex items-center justify-center gap-3 text-papel/65 font-mono text-[11px] tracking-[0.24em] uppercase">
          <span>SCROLL</span>
          <svg width="14" height="22" viewBox="0 0 14 22" fill="none" stroke="currentColor" strokeWidth="1" aria-hidden>
            <rect x="1" y="1" width="12" height="20" rx="6" />
            <circle className="scroll-cue-bead" cx="7" cy="7" r="1.6" fill="currentColor" />
          </svg>
        </div>
      </div>
    </section>
  );
}
